import React from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { useDailyAgendaActions } from '../../../../../components/DailyAgenda/hooks/useDailyAgendaActions';
import { AgendaItemViewModel } from '../../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';
import { LayoutTypes } from '../../../../../types/types';
import { agendaItemLayoutFactory } from './AgendaItemLayoutFactory';
import {
  WidgetComponents,
  WidgetElements,
} from '../../../../../utils/bi/consts';
import { READ_MORE_LINK_EXPERIMENT } from '../../../../../utils/settings/consts';

export type AgendaItemProps = {
  layoutType: LayoutTypes;
  agendaItemViewModel: AgendaItemViewModel;
};

export const AgendaItem: React.FC<AgendaItemProps> = ({
  layoutType,
  agendaItemViewModel,
}) => {
  const { onSlotClick, onElementClicked, onReadMoreClick } =
    useDailyAgendaActions();
  const { experiments } = useExperiments();
  const isReadMoreEnabled = experiments.enabled(READ_MORE_LINK_EXPERIMENT);
  const RenderAgendaItemLayout = agendaItemLayoutFactory[layoutType];

  const handleSlotClick = (slotId: string): Promise<void> => {
    onElementClicked(WidgetComponents.AGENDA_ITEM, WidgetElements.BOOK_BUTTON);
    return onSlotClick(slotId);
  };

  return (
    <RenderAgendaItemLayout
      key={agendaItemViewModel.slotId}
      onSlotClick={handleSlotClick}
      onReadMoreClick={isReadMoreEnabled ? onReadMoreClick : undefined}
      agendaItemViewModel={agendaItemViewModel}
    />
  );
};
